<template>
  <div class="user-center__cart-container user-center__common-child-container">
    <div class="cart__wrapper">
      <SubPageHeader>
        <template #title>
          <router-link
            tag="div"
            :to="nav.url"
            active-class="active"
            class="title__front-item"
            v-for="(nav, index) in breadcrumbs"
            :key="index"
            >{{ nav.name }}</router-link
          >
        </template>
      </SubPageHeader>
      <div class="cart__main-body">
        <el-checkbox-group class="cart__options-container" v-model="options" v-if="carts.length">
          <el-checkbox-button
            class="option__item"
            v-for="item in carts"
            :key="item.id"
            :label="item.id"
          >
            <div class="item__checkbox-sign"></div>
            <div class="item__cover">
              <img :src="item.title_picture_url | parseImage" alt="" />
            </div>
            <div class="item__name">
              <p class="name__text">{{ item.name }}</p>
              <p class="name__type">{{ item.mold_name }}</p>
            </div>
            <div class="item__price">￥{{ item.price }}</div>
            <div class="item__add-counts" style="display:none">
              <div class="add-coutns__grid" @click.stop="changeCounts">-</div>
              <div class="add-coutns__grid">1</div>
              <div class="add-coutns__grid" @click.stop="changeCounts">+</div>
            </div>
            <div class="item__result">
              <p class="result__text">￥{{ item.price }}</p>
              <p
                class="result__delete-bt"
                @click.stop.prevent="cnmb"
                :data-samplid="item.sample_id"
              >
                删除
              </p>
            </div>
          </el-checkbox-button>
        </el-checkbox-group>
        <empty hint="没有找到相关信息" v-else></empty>
      </div>
    </div>
    <div class="cart__bill-info">
      <div class="info__wrapper">
        <div class="select__all-bt" @click="selectAll"
          :class="{
            actived: options.length > 0 && options.length === carts.length
          }"
        >
          <div class="all__container">
            <div class="checkbox__sign"></div>
            <div class="all__text">
              <span>全选</span>
              <span>|</span>
              <span>已选{{ options.length }}件</span>
            </div>
          </div>
        </div>
        <div class="info__body">
          <div class="body__text">
            <span>商品包邮</span>
            <span>|</span>
            <span>总计 ￥{{ totalPrice }}</span>
          </div>
          <div class="body__sumbit-order" @click="onCheckout">立即下单</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import Empty from '@/pages/common/empty.vue';
import SubPageHeader from '../_pageHeader.vue';

export default {
  components: {
    SubPageHeader,
    Empty,
  },
  data() {
    return {
      breadcrumbs: [
        {
          name: '我的购物车',
          url: '/my/cart',
        },
      ],
      options: [],
      carts: [],
    };
  },
  watch: {
    $route: {
      handler: 'init',
      immediate: true,
    },
    filtersCarts(val) {
      this.carts = val;
    },
  },
  computed: {
    ...mapGetters('user', {
      filtersCarts: 'uniqueCarts',
    }),
    totalPrice() {
      if (this.options.length > 0) {
        const carts = this.carts
          .filter((item) => this.options.includes(item.id))
          .map((item) => Number(item.price));
        return carts.reduce((total, item) => total + item);
      }
      return 0;
    },
  },
  created() {
    //
  },
  methods: {
    ...mapActions('user', ['getCarts', 'delCarts']),
    ...mapMutations('user', ['SET_CHECKOUT']),
    async init() {
      this.$store.commit('openLoading');
      await this.getCarts();
      this.$store.commit('closeLoading');
    },
    async cnmb(e) {
      const { samplid } = e.currentTarget.dataset;
      this.$store.commit('openLoading');
      try {
        const removedCartid = await this.delCarts(samplid);
        console.log(removedCartid);
      } catch (err) {
        console.log(err);
      }
      this.$store.commit('closeLoading');
    },
    selectAll() {
      this.options = this.carts.map((item) => item.id);
    },
    onCheckout() {
      if (this.options.length === 0) {
        this.$message({
          type: 'error',
          message: '请选择至少一件商品',
        });
      } else {
        const carts = this.carts
          .filter((item) => this.options.includes(item.id))
          .map((item) => Number(item.sample_id));
        this.SET_CHECKOUT(carts);
        this.$router.push({
          path: '/my/checkout',
        });
      }
    },
  },
};
</script>

<style>
.user-center__main-container {
  padding-bottom: 0 !important;
}
</style>
